import { Fetcher } from '../../Fetcher';

import { AssignedTablesType } from './types';

export interface FetchAssignedTablesParams {
  JSESSIONID: string;
  url: string;
}

export const fetchAssignedTables = ({ JSESSIONID, url }: FetchAssignedTablesParams): Promise<AssignedTablesType> => {
  return Fetcher.fetch<string>(url, {
    params: {
      JSESSIONID,
      game_mode: 'lobby_desktop',
    },
    format: 'text',
  }).then(xml2AssignedTables);
};

export const xml2AssignedTables = (str: string): AssignedTablesType => {
  const xml = new window.DOMParser().parseFromString(str.trim(), 'application/xml');
  const tableGroupList = xml.querySelector('gametable');

  const tableGroupExceptions = ['mtbGroups'];

  const assignedTables: AssignedTablesType = [];

  if (tableGroupList && tableGroupList.children.length > 0) {
    for (const tableGroup of tableGroupList.children) {
      if (tableGroup.children && tableGroup.children.length > 0 && !tableGroupExceptions.includes(tableGroup.tagName)) {
        for (const table of tableGroup.children) {
          const id = table.getAttribute('id');
          const name = table.getAttribute('name');
          const operatorGameId = table.getAttribute('operatorgameid');

          if (id && name && operatorGameId) {
            assignedTables.push({
              id,
              name,
              operatorGameId,
            });
          }
        }
      }
    }
  }

  return assignedTables;
};
